import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { IInitUploadRequest, IInitUploadResponse, IUploadChunkRequest } from './models/documentCache';
import { AxiosRequestConfig, Method } from 'axios';

export default class DocumentCacheApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + 'services/documentcache'
		};
	}

	public async initUploadAsync(data: IInitUploadRequest): Promise<IInitUploadResponse> {
		const request: AxiosRequestConfig = {
			...this.createBaseRequest(),
			url: '/InitUpload',
			method: 'post' as Method,
			data: { fileSize: data.fileSize, fileExtension: data.fileExtension },
			cancelToken: data.cancellationToken
		};

		const response = await super.sendAsync<IInitUploadResponse>(request);
		this.throwIfFailedResponse(response, localize('Error initializing document upload.'));
		return response.data;
	}

	public async uploadChunkAsync(data: IUploadChunkRequest): Promise<boolean> {
		const formData = new FormData();
		formData.append('chunk', data.chunk);

		const request: AxiosRequestConfig = {
			...this.createBaseRequest(),
			url: '/UploadChunk',
			method: 'post' as Method,
			data: formData,
			headers: { 'Content-Type': 'multipart/form-data' },
			params: {
				chunkIndex: data.chunkIndex,
				uploadToken: data.uploadToken
			},
			cancelToken: data.cancellationToken
		};

		const response = await super.sendAsync<boolean>(request);
		this.throwIfFailedResponse(response, localize('Error while uploading a document chunk.'));
		return response.data;
	}
}
